export default "__VITE_ASSET__2eba5ddb__"